import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ConglomeradoService } from "../../conglomerado.service";
import { ParticipanteConglomerado } from "src/app/model/participante.conglomerado.model";
import { Cotista } from "src/app/model/cotista.model";
import { TipoCotistaEnum } from "src/app/model/tipo-cotista-enum";


@Component({
    selector: 'label-conglomerado-dica',
    templateUrl: './label-conglomerado-dica.component.html',
    standalone: false
})
export class LabelConglomeradoDicaComponent implements OnChanges {
  @Input() cotistaSelecionado: Cotista;
  participantesConglomerado: ParticipanteConglomerado[] = [];
  mostrarLabel: boolean = false;

  constructor(private conglomeradoService: ConglomeradoService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.carregarParticipantesConglomerado();
  }

  async carregarParticipantesConglomerado() {
    console.log('this.cotistaSelecionado', this.cotistaSelecionado);

    if (this.cotistaSelecionado && this.cotistaSelecionado.tipoCotista === TipoCotistaEnum.AGENTE_FINANCEIRO) {
      this.participantesConglomerado = await this.conglomeradoService
        .buscarAtivosPorAgente(this.cotistaSelecionado.id).toPromise();
    } else {
      this.participantesConglomerado = [];
    }
    this.mostrarLabel = this.participantesConglomerado.length > 0
  }
}
